import Header from "./Header";
import Footer from "./Footer";
import ScrollToTop from "../ui/ScrollToTop";
import FloatingWhatsaap from "../ui/FloatingWhatsaap";

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen relative flex flex-col">
      <Header />
      <main className="flex-grow">{children}</main>
      <Footer />
      <ScrollToTop />
      <FloatingWhatsaap />
    </div>
  );
};

export default Layout;
